
const convertHexToRgb = (hexValue) => {
  const rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexValue);
  return rgb ? {
    r: parseInt(rgb[1], 16),
    g: parseInt(rgb[2], 16),
    b: parseInt(rgb[3], 16)
  } : null;
};

const progressBarBackgroundColor: (progress: number, theme: any) => string = (progress, theme) => { // return bg color based on current percentage
  const progressPercent = (progress < 100 ? progress : 100) / 100;
  const begin = convertHexToRgb(theme.progressInitialColor);
  const end = convertHexToRgb(theme.progressFinalColor);
  const RGB_BEGIN = [begin.r, begin.g, begin.b];
  const RGB_END = [end.r, end.g, end.b];
  if (progress > 0.05) {
    const w = (progressPercent * 2) - 1;
    const w1 = (w + 1) / 2;
    const w2 = 1 - w1;
    const rgb = [
      parseInt(`${(RGB_END[0] * w1) + (RGB_BEGIN[0] * w2)}`, 10),
      parseInt(`${(RGB_END[1] * w1) + (RGB_BEGIN[1] * w2)}`, 10),
      parseInt(`${(RGB_END[2] * w1) + (RGB_BEGIN[2] * w2)}`, 10)
    ];
    return rgb.toString();
  }
  return RGB_BEGIN.toString();
};

export default progressBarBackgroundColor;